(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["camo-hero-slider"] && !Shopify.designMode) return;
  try {
    
	(() => {
		const selectors = {
			root: '[data-camo-hero-slider]',
			slide: '[data-camo-hero-slide]',
			dot: '[data-camo-hero-dot]'
		};

		const initSlider = (root) => {
			if (root.dataset.camoHeroReady === 'true') return;

			const slides = Array.from(root.querySelectorAll(selectors.slide));
			const dots = Array.from(root.querySelectorAll(selectors.dot));
			const autoplay = root.dataset.autoplay === 'true';
			const delay = Number(root.dataset.delay) || 5000;
			let activeIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
			let timer = null;
			let transitionTimer = null;
			let mouseHovered = false;
			const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
			let pointerStart = null;
			let pointerStartY = null;
			let pointerCurrent = null;
			let pointerCurrentY = null;
			let preventClick = false;

			const setActive = (index) => {
				if (slides.length === 0) return;
				if (transitionTimer) window.clearTimeout(transitionTimer);
				transitionTimer = null;
				clearSwipeClasses();

				activeIndex = (index + slides.length) % slides.length;

				slides.forEach((slide, slideIndex) => {
					const isActive = slideIndex === activeIndex;
					slide.classList.toggle('is-active', isActive);
					slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');

					if (isActive) {
						const desktopAspect = slide.style.getPropertyValue('--camo-hero-aspect-desktop');
						const mobileAspect = slide.style.getPropertyValue('--camo-hero-aspect-mobile');
						if (desktopAspect) root.style.setProperty('--camo-hero-aspect-desktop', desktopAspect);
						if (mobileAspect) root.style.setProperty('--camo-hero-aspect-mobile', mobileAspect);
					}
				});

				dots.forEach((dot, dotIndex) => {
					const isActive = dotIndex === activeIndex;
					dot.classList.toggle('is-active', isActive);
					dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
				});
			};

			const clearSwipeClasses = () => {
				root.classList.remove('is-swipe-next', 'is-swipe-prev');
				slides.forEach((slide) => {
					slide.classList.remove('is-swipe-from', 'is-swipe-to');
				});
			};

			const slideTo = (index, direction) => {
				if (slides.length <= 1) return;

				const fromIndex = activeIndex;
				const toIndex = (index + slides.length) % slides.length;
				if (fromIndex === toIndex) return;
				if (reducedMotion.matches) {
					setActive(toIndex);
					return;
				}

				setActive(fromIndex);
				root.classList.add(direction === 'prev' ? 'is-swipe-prev' : 'is-swipe-next');
				slides[fromIndex].classList.add('is-swipe-from');
				slides[toIndex].classList.add('is-swipe-to');
				slides[toIndex].setAttribute('aria-hidden', 'false');
				activeIndex = toIndex;

				dots.forEach((dot, dotIndex) => {
					const isActive = dotIndex === activeIndex;
					dot.classList.toggle('is-active', isActive);
					dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
				});

				const desktopAspect = slides[toIndex].style.getPropertyValue('--camo-hero-aspect-desktop');
				const mobileAspect = slides[toIndex].style.getPropertyValue('--camo-hero-aspect-mobile');
				if (desktopAspect) root.style.setProperty('--camo-hero-aspect-desktop', desktopAspect);
				if (mobileAspect) root.style.setProperty('--camo-hero-aspect-mobile', mobileAspect);

				transitionTimer = window.setTimeout(() => {
					setActive(toIndex);
				}, 500);
			};

			const stop = () => {
				if (timer) window.clearInterval(timer);
				timer = null;
			};

			const start = () => {
				stop();
				if (autoplay && slides.length > 1 && !reducedMotion.matches && !mouseHovered) {
					timer = window.setInterval(() => slideTo(activeIndex + 1, 'next'), delay);
				}
			};

			const goTo = (index) => {
				slideTo(index, index < activeIndex ? 'prev' : 'next');
				start();
			};

			root.addEventListener('pointerenter', (event) => {
				if (event.pointerType !== 'mouse') return;
				mouseHovered = true;
				stop();
			});
			root.addEventListener('pointerleave', (event) => {
				if (event.pointerType !== 'mouse') return;
				mouseHovered = false;
				start();
			});

			dots.forEach((dot) => {
				dot.addEventListener('click', () => goTo(Number(dot.dataset.slideIndex)));
			});

			root.addEventListener('pointerdown', (event) => {
				if (!event.isPrimary) return;
				pointerStart = event.clientX;
				pointerStartY = event.clientY;
				pointerCurrent = event.clientX;
				pointerCurrentY = event.clientY;
				preventClick = false;
				root.classList.add('is-dragging');
			});

			root.addEventListener('pointermove', (event) => {
				if (pointerStart === null || !event.isPrimary) return;
				pointerCurrent = event.clientX;
				pointerCurrentY = event.clientY;
				const distance = pointerCurrent - pointerStart;
				const verticalDistance = Math.abs(pointerCurrentY - pointerStartY);
				const horizontalDistance = Math.abs(distance);
				if (horizontalDistance > 10 && horizontalDistance > verticalDistance) {
					event.preventDefault();
				}
			});

			root.addEventListener('pointerup', (event) => {
				if (pointerStart === null) return;
				const distance = (pointerCurrent || event.clientX) - pointerStart;
				const verticalDistance = Math.abs((pointerCurrentY || event.clientY) - pointerStartY);
				const horizontalDistance = Math.abs(distance);
				pointerStart = null;
				pointerStartY = null;
				pointerCurrent = null;
				pointerCurrentY = null;
				root.classList.remove('is-dragging');

				if (horizontalDistance > 32 && horizontalDistance > verticalDistance) {
					preventClick = true;
					stop();
					if (distance < 0) {
						slideTo(activeIndex + 1, 'next');
					} else {
						slideTo(activeIndex - 1, 'prev');
					}
					start();
					window.setTimeout(() => {
						preventClick = false;
					}, 300);
				}
			});

			root.addEventListener('pointercancel', () => {
				pointerStart = null;
				pointerStartY = null;
				pointerCurrent = null;
				pointerCurrentY = null;
				root.classList.remove('is-dragging');
			});

			root.addEventListener('click', (event) => {
				if (preventClick) {
					event.preventDefault();
					event.stopPropagation();
					return;
				}
			}, true);

			root.addEventListener('dragstart', (event) => {
				event.preventDefault();
			});

			document.addEventListener('shopify:block:select', (event) => {
				if (!root.contains(event.target)) return;
				const selectedSlide = event.target.closest(selectors.slide);
				if (!selectedSlide) return;
				stop();
				setActive(Number(selectedSlide.dataset.slideIndex));
			});

			reducedMotion.addEventListener('change', () => {
				if (reducedMotion.matches) setActive(activeIndex);
				start();
			});

			root.dataset.camoHeroReady = 'true';
			setActive(activeIndex);
			start();
		};

		const initAllSliders = () => {
			document.querySelectorAll(selectors.root).forEach(initSlider);
		};

		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', initAllSliders);
		} else {
			initAllSliders();
		}

		window.addEventListener('load', initAllSliders);

		document.addEventListener('shopify:section:load', (event) => {
			const loadedRoot = event.target.querySelector(selectors.root);
			if (loadedRoot) initSlider(loadedRoot);
		});
	})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["christmas-gift-guide"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initCategories(scope) {
      scope.querySelectorAll('[data-christmas-categories]:not([data-category-ready])').forEach(nav => {
        nav.dataset.categoryReady = 'true';
        const track = nav.querySelector('.christmas-guide__category-grid');
        const pages = [...track.querySelectorAll('.christmas-guide__category-page')];
        const buttons = [...nav.querySelectorAll('[data-category-page]')];
        const mobile = matchMedia('(max-width: 767px)');
        const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        let current = 0;
        let frame;
        const pageOffset = index => Math.min(pages[index].offsetLeft - pages[0].offsetLeft, Math.max(0, track.scrollWidth - track.clientWidth));
        const update = () => {
          current = mobile.matches ? pages.reduce((closest, page, index) => Math.abs(track.scrollLeft - pageOffset(index)) < Math.abs(track.scrollLeft - pageOffset(closest)) ? index : closest, 0) : 0;
          buttons.forEach((button, index) => button.setAttribute('aria-pressed', String(index === current)));
        };
        const goTo = index => {
          if (!mobile.matches) return;
          track.scrollTo({ left: pageOffset(Math.max(0, Math.min(index, pages.length - 1))), behavior: reducedMotion.matches ? 'instant' : 'smooth' });
        };
        buttons.forEach((button, index) => button.addEventListener('click', () => goTo(index)));
        track.addEventListener('scroll', () => {
          cancelAnimationFrame(frame);
          frame = requestAnimationFrame(update);
        }, { passive: true });
        track.addEventListener('keydown', event => {
          if (event.target !== track || !mobile.matches) return;
          const targets = { ArrowRight: current + 1, ArrowLeft: current - 1, Home: 0, End: pages.length - 1 };
          if (!(event.key in targets)) return;
          event.preventDefault();
          goTo(targets[event.key]);
        });
        mobile.addEventListener('change', () => {
          track.scrollTo({ left: 0, behavior: 'instant' });
          update();
        });
        update();
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initCategories(document));
    else initCategories(document);
    document.addEventListener('shopify:section:load', event => initCategories(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-recommendations"] && !Shopify.designMode) return;
  try {
    
(() => {
  const requests = new Map();
  const normalize = value => String(value || '').trim().toLowerCase();
  const designTags = product => (product.tags || []).map(normalize).filter(tag => tag.startsWith('design:'));
  const designStem = product => normalize(product.handle).replace(/-(?:back|front)$/, '').replace(/-(?:sun-protection-hoodie|waterproof-jacket|fleece-hoodie|long-sleeve|long-sleeves|pocket-tee|t-shirt|sweatshirt|hoodie|youth-tee|jersey)$/, '');
  function score(product, current, classification) {
    const tags = designTags(current);
    const sameDesign = designTags(product).some(tag => tags.includes(tag));
    const stem = designStem(current);
    const sameStem = stem.length > 3 && stem === designStem(product);
    const excluded = new Set([...Object.values(classification), 'all', 'frontpage', 'new-arrival', 'new-arrivals', 'best-seller', 'best-sellers']);
    const themes = (current.collections || []).filter(handle => !excluded.has(handle));
    const overlap = (product.collections || []).filter(handle => themes.includes(handle)).length;
    return (sameDesign || sameStem ? 10000 : 0) + overlap;
  }
  function selectProducts(config, pools, excluded) {
    const selected = new Set([config.current.handle, ...excluded]);
    if (config.fixedProducts) {
      return config.fixedProducts.filter(product => !selected.has(product.handle))
        .map(product => ({...product, group: 'holiday-picks'}));
    }
    const classified = Object.entries(config.classification);
    const relatedCollections = config.relatedCollections || [];
    const collectionIndex = product => relatedCollections.findIndex(handle => (product.collections || []).includes(handle));
    const byPriority = (a, b) => a.collectionIndex - b.collectionIndex || b.rank - a.rank || a.index - b.index;
    const ranked = config.groups.map(group => (pools.get(group.key) || []).filter(product => {
      if (!product.available || !product.physical || selected.has(product.handle)) return false;
      if (collectionIndex(product) < 0) return false;
      const allowedTypes = config.typeGroups?.[group.key];
      if (allowedTypes) return allowedTypes.includes(product.productType);
      const category = classified.find(([, handle]) => (product.collections || []).includes(handle));
      return category && category[0] === group.key;
    }).map((product, index) => ({product, index, collectionIndex: collectionIndex(product), rank: score(product, config.current, config.classification)}))
      .sort(byPriority));
    const buckets = ranked.map(() => []);
    const take = (index, count) => {
      for (const {product} of ranked[index]) {
        if (count <= 0) break;
        if (selected.has(product.handle)) continue;
        selected.add(product.handle);
        buckets[index].push({...product, group: config.groups[index].key});
        count -= 1;
      }
    };
    // Fill each quota from the smallest collection first, advancing only for missing slots.
    config.groups.forEach((group, index) => take(index, group.quota));
    let missing = 8 - buckets.flat().length;
    // Reallocate only after all related collections have been exhausted for a missing group.
    const remaining = ranked.flatMap((items, groupIndex) => items.map(item => ({...item, groupIndex}))).sort(byPriority);
    for (const {product, groupIndex} of remaining) {
      if (missing <= 0) break;
      if (selected.has(product.handle)) continue;
      selected.add(product.handle);
      buckets[groupIndex].push({...product, group: config.groups[groupIndex].key});
      missing -= 1;
    }
    const result = [];
    const secondary = buckets.slice(1);
    const second = [];
    while (secondary.some(bucket => bucket.length)) {
      secondary.forEach(bucket => { if (bucket.length) second.push(bucket.shift()); });
    }
    while (buckets[0]?.length || second.length) {
      if (buckets[0]?.length) result.push(buckets[0].shift());
      if (second.length) result.push(second.shift());
    }
    return result.slice(0, 8);
  }
  async function cachedFetch(url) {
    const key = url.toString();
    if (!requests.has(key)) {
      const request = fetch(key, {signal: AbortSignal.timeout(15000), credentials: 'same-origin'})
        .then(response => {
          if (!response.ok) throw new Error(`Collection cross-sell: HTTP ${response.status}`);
          return response.text();
        }).catch(error => { requests.delete(key); throw error; });
      requests.set(key, request);
    }
    return requests.get(key);
  }
  async function limitedMap(items, action) {
    const result = new Array(items.length);
    let cursor = 0;
    await Promise.all(Array.from({length: Math.min(4, items.length)}, async () => {
      while (cursor < items.length) {
        const index = cursor++;
        try { result[index] = await action(items[index]); } catch { result[index] = null; }
      }
    }));
    return result;
  }
  async function loadCollection(group) {
    if (!group.url || !group.handle) return [];
    const url = new URL(group.url, location.origin);
    url.searchParams.set('view', 'cross-sell-candidates');
    url.searchParams.set('page', '1');
    const first = JSON.parse(await cachedFetch(url));
    if (first.collection !== group.handle) throw new Error('Unexpected recommendation collection');
    const pages = Array.from({length: Math.max(0, Math.min(first.pages, 250) - 1)}, (_, index) => index + 2);
    const rest = await limitedMap(pages, async page => {
      const next = new URL(url);
      next.searchParams.set('page', page);
      const data = JSON.parse(await cachedFetch(next));
      if (data.collection !== group.handle || data.page !== page) throw new Error('Unexpected recommendation page');
      return data.products;
    });
    return [...first.products, ...rest.filter(Boolean).flat()];
  }
  class CollectionRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.run = 0;
      this.failed = new Set();
      this.config = JSON.parse(this.querySelector('[data-collection-recommendation-config]').textContent);
      this.section = this.querySelector('section');
      this.row = this.querySelector('.swiper-wrapper');
      this.slider = this.querySelector('.swiper');
      this.onThemeReady = () => this.mountSlider();
      document.addEventListener('theme:all:loaded', this.onThemeReady);
      if ('IntersectionObserver' in window && !window.Shopify?.designMode) {
        this.intersection = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {
            this.intersection.disconnect();
            this.load();
          }
        }, {rootMargin: '1000px'});
        this.intersection.observe(this);
      } else this.load();
    }
    disconnectedCallback() {
      this.started = false;
      this.run += 1;
      this.intersection?.disconnect();
      this.existingObserver?.disconnect();
      this.resize?.disconnect();
      clearTimeout(this.refreshTimer);
      this.slider?.swiper?.destroy(true, true);
      document.removeEventListener('theme:all:loaded', this.onThemeReady);
    }
    excludedHandles() {
      const handles = new Set(this.failed);
      if (this.config.fixedProducts) return handles;
      document.querySelectorAll('.product-recommendations').forEach(section => {
        if (this.contains(section)) return;
        section.querySelectorAll('.js-featured-products-slide[data-product-handle]').forEach(slide => {
          if (!slide.classList.contains('product-recommendations__candidate-fallback') && !slide.hidden) {
            handles.add(slide.dataset.productHandle);
          }
        });
      });
      return handles;
    }
    async load() {
      if (this.loading) return;
      this.loading = true;
      const generation = this.run;
      const lists = this.config.fixedProducts ? [] : await limitedMap(this.config.groups, group => loadCollection(group));
      if (!this.isConnected || generation !== this.run) return;
      this.pools = new Map(this.config.groups.map((group, index) => [group.key, lists[index] || []]));
      await this.refresh();
      if (!this.isConnected) return;
      this.existingObserver = new MutationObserver(() => {
        clearTimeout(this.refreshTimer);
        this.refreshTimer = setTimeout(() => this.refresh(), 200);
      });
      document.querySelectorAll('.product-recommendations').forEach(section => {
        if (!this.contains(section)) this.existingObserver.observe(section, {
          childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'data-product-handle']
        });
      });
      this.refresh();
    }
    async refresh() {
      if (!this.pools || !this.isConnected) return;
      const generation = ++this.run;
      let picks = selectProducts(this.config, this.pools, this.excludedHandles());
      const signature = picks.map(product => product.handle).join(',');
      if (signature === this.signature) return;
      let cards = [];
      for (let attempt = 0; attempt < 3; attempt += 1) {
        cards = await limitedMap(picks, async product => {
          const url = new URL(product.url, location.origin);
          url.searchParams.set('view', 'cross-sell-card');
          const parsed = new DOMParser().parseFromString(await cachedFetch(url), 'text/html');
          const card = parsed.querySelector('.js-featured-products-slide');
          if (!card || card.dataset.productHandle !== product.handle) throw new Error('Unavailable recommendation');
          card.dataset.collectionRecommendationGroup = product.group;
          return card;
        });
        if (!this.isConnected || generation !== this.run) return;
        const missing = picks.filter((_, index) => !cards[index]);
        if (!missing.length) break;
        missing.forEach(product => this.failed.add(product.handle));
        if (attempt < 2) picks = selectProducts(this.config, this.pools, this.excludedHandles());
      }
      // The upper section can change while product cards are being fetched.
      const excluded = this.excludedHandles();
      if (cards.some(card => card && excluded.has(card.dataset.productHandle))) return this.refresh();
      this.slider.swiper?.destroy(true, true);
      this.row.replaceChildren(...cards.filter(Boolean));
      this.signature = picks.map(product => product.handle).join(',');
      this.section.hidden = !this.row.children.length;
      this.dataset.loaded = 'true';
      this.dataset.count = String(this.row.children.length);
      if (this.row.children.length) this.mountSlider();
    }
    mountSlider() {
      const Swiper = window.themeCore?.utils?.Swiper;
      if (!Swiper || !this.isConnected || this.section.hidden) return;
      if (this.slider.swiper) { this.slider.swiper.update(); return; }
      const prev = this.querySelector('.product-recommendations__arrow--prev');
      const next = this.querySelector('.product-recommendations__arrow--next');
      const pagination = this.querySelector('.product-recommendations__mobile-pagination');
      const updateLayout = () => {
        this.section.classList.toggle('is-mobile-layout', this.section.clientWidth < 768);
        const image = this.row.querySelector('.product-card__image');
        if (image) this.querySelector('.product-recommendations__carousel-shell').style.setProperty('--product-recommendations-arrow-top', `${image.offsetTop + image.offsetHeight / 2}px`);
      };
      updateLayout();
      new Swiper(this.slider, {
        grabCursor: true,
        speed: matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 550,
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 16,
        roundLengths: false,
        watchOverflow: true,
        rewind: true,
        breakpoints: {768: {slidesPerView: 3, slidesPerGroup: 3, spaceBetween: 12}, 1200: {slidesPerView: 4, slidesPerGroup: 4, spaceBetween: 12}},
        navigation: {prevEl: prev, nextEl: next},
        pagination: {el: pagination, type: 'bullets', clickable: true, bulletElement: 'button'},
        on: {init: () => this.section.classList.add('is-initialized'), resize: updateLayout}
      });
      this.resize?.disconnect();
      this.resize = new ResizeObserver(updateLayout);
      this.resize.observe(this.section);
    }
  }
  if (!customElements.get('collection-recommendations')) customElements.define('collection-recommendations', CollectionRecommendations);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dual-promo-banners"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-dual-promo-banners]';

    const initSection = (section) => {
      if (!section || section.dataset.dualPromoReady === 'true') return;

      section.dataset.dualPromoReady = 'true';
      section.classList.add('is-ready');

      if (!section.classList.contains('dual-promo-banners--animate')) {
        section.classList.add('is-visible');
        return;
      }

      if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        section.classList.add('is-visible');
        return;
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          section.classList.add('is-visible');
          observer.disconnect();
        });
      }, {
        rootMargin: '0px 0px -6% 0px',
        threshold: 0.08
      });

      observer.observe(section);
    };

    const initAll = (scope = document) => {
      scope.querySelectorAll(selector).forEach(initSection);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hunt-essentials-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hunt-essentials')) {
    customElements.define('hunt-essentials', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.hunt-essentials__track');
        if (!this.track || this.abortController) return;
        this.abortController = new AbortController();
        const signal = this.abortController.signal;
        this.pages = [...this.querySelectorAll('.hunt-essentials__page')];
        this.buttons = [...this.querySelectorAll('[data-direction]')];
        this.buttons.forEach(button => button.addEventListener('click', () => {
          this.goTo(this.currentPage + Number(button.dataset.direction));
        }, { signal }));
        this.track.addEventListener('scroll', () => this.update(), { signal, passive: true });
        this.addEventListener('shopify:block:select', event => {
          const selectedPage = event.target.closest('.hunt-essentials__page');
          const index = this.pages.indexOf(selectedPage);
          if (index >= 0) this.goTo(index);
        }, { signal });
        this.track.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let page = this.currentPage + (event.key === 'ArrowRight' ? 1 : -1);
          if (event.key === 'Home') page = 0;
          if (event.key === 'End') page = this.pages.length - 1;
          this.goTo(page);
        }, { signal });
        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this.track);
        this.update();
      }
      disconnectedCallback() {
        this.abortController?.abort();
        this.abortController = null;
        this.resizeObserver?.disconnect();
      }
      goTo(page) {
        const index = Math.max(0, Math.min(this.pages.length - 1, page));
        this.track.scrollTo({ left: index * this.track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
      update() {
        this.currentPage = Math.round(this.track.scrollLeft / (this.track.clientWidth || 1));
        this.buttons.forEach(button => {
          button.disabled = Number(button.dataset.direction) < 0 ? this.currentPage === 0 : this.currentPage >= this.pages.length - 1;
        });
        this.pages.forEach((page, index) => { page.inert = index !== this.currentPage; });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
